import { CookieCogIcon } from './CookieCogIcon';

/**
 * author: Colton Wiscombe
 * id 5923CF0C-4D34-4BF1-8401-3AEEDC0DE9BC
 * name cookie-cog
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-cog.svg
 * tags
 * - Food / Drink 
 * - Settings 
 */
export const BiscuitCogIcon = CookieCogIcon;
export default BiscuitCogIcon